import * as React from 'react';
import * as ReactDOM from 'react-dom';
import EventListener from 'react-event-listener';


type MouseEventEnum = 'onClick' | 'onMouseUp' | 'onMouseDown' | 'onMouseOver';

interface IProps {
    onClickAway: (event: React.MouseEvent<any>) => void;
    mouseEvent?: MouseEventEnum;
    children: React.ReactElement<React.SFC>;
    getChildNode?: () => any;
}

export default class ClickAwayListener extends React.Component<IProps>{

    private mounted = false;

    public componentDidMount() {
        this.mounted = true;
    }

    public componentWillUnmount() {
        this.mounted = false;
    }

    private getNode = () => {
        if (this.props.getChildNode) {
            return this.props.getChildNode();
        }
        return ReactDOM.findDOMNode(this);
    }

    private clickAwayHandle = (event: React.MouseEvent) => {
        if (event.defaultPrevented) { return; }

        if (!this.mounted) { return; }

        const node = this.getNode();

        if (!node) { return; }

        const doc = (node && node.ownerDocument) || document;

        if (
            doc.documentElement &&
            doc.documentElement.contains(event.target) &&
            !node.contains(event.target)
        ) {
            this.props.onClickAway(event);
        }
    }

    public render() {
        const { children, mouseEvent = 'onClick' } = this.props;
        const listenerProps = {
            [mouseEvent]: this.clickAwayHandle
        };

        return (
            <React.Fragment>
                {children}
                <EventListener target="document" {...listenerProps} />
            </React.Fragment>
        );
    }
}
